import addEventListener from 'utils/DOM/addEventListener'
import { PIVOT_ORGANIC_DOMAIN } from 'core/constants/endpoints'
import storage from 'proxy-storage'

function handleMessage(e) {
  if (e.origin !== PIVOT_ORGANIC_DOMAIN) {
    return
  }

  // check for data in localStorage
  const hcStorage = storage.getItem('hc')
  let message = 'stay'

  if (hcStorage && hcStorage.healthcareUserId && hcStorage.agent_id) {
    message = 'goToEnroll'
  }

  e.source.postMessage(message, e.origin)
}

addEventListener(window, 'message', handleMessage, false)
